module.exports = __webpack_public_path__ + "static/img/3.5467f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/3.png
// module id = PTz7
// module chunks = 0